import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import PageTitle from "../../components/pagetitle";
import Appointment from "../../components/Appointment";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";

const AppointmentPage = () => {
  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-2"} topbarBlock={"topbar-block"} />
      <PageTitle pageTitle={"Appoinment"} pagesub={"Appoinment"} />
      <Appointment />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AppointmentPage;
